module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ga-ccf7eecbecdd26d2403c01bab2c28528.svg";